import { TIME_LINE_GROUP_PREFIX } from '@constants'

export const isGroupTitleRow = (id?: string) => {
  if (!id) {
    return false
  }

  return id.startsWith(TIME_LINE_GROUP_PREFIX)
}
